module.exports = __webpack_public_path__ + "img/5-ilpakamaniotroMAS.9ff63e48.jpg";